import {
  Box,
  Button,
  Flex,
  IconButton,
  Menu,
  MenuItem,
  MenuItemOption,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { flexRender, getCoreRowModel, getSortedRowModel, useReactTable, createColumnHelper } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'components/Toast';
import { useUserState } from 'context/UserContext';
import { useCreateWebhookMutation, useDelBotTeleListMutation, useDelWebhooktMutation, useUpdateBotTeleStatusMutation } from 'services/bottelegram';
import AuthorizationComponentWrapper from 'components/AuthorizationComponentWrapper/AuthorizationComponentWrapper';
import { ModalType } from 'constants/common';
import { IoIosCreate } from "react-icons/io";
import { MdDeleteOutline } from "react-icons/md";



const SizeTable = ({ botTeleTable, handleUpdateBotTele, refetch }) => {
  const [sorting, setSorting] = useState([]);
  const [rowSelection, setRowSelection] = useState([]);
  const deleteLinkMutation = useDelBotTeleListMutation();
  const deleteWebhook = useDelWebhooktMutation();
  const createWebhook = useCreateWebhookMutation();
  const changeBotTeleStatusMutation = useUpdateBotTeleStatusMutation();
  const { userInfo } = useUserState();


  const handleRowClick = (shortlink, type) => {
    handleUpdateBotTele(shortlink, type);
  };

  const handleDeleteBotTele = async botTeleDetail => {
  const confirmDelete = window.confirm('Bạn có chắc chắn muốn xóa đường dẫn này không?');
    if (!confirmDelete) {
      return;
    }
    deleteLinkMutation.mutate(
        { telegramId: botTeleDetail?._id },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Xóa đường dẫn thành công');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Xóa đường dẫn không thành công');
          refetch?.();
        },
      }
    );
  };
  const handleDeleteWebhook = async (data) =>{
    const confirmDelete = window.confirm("Bạn có muốn xóa Webhook này không ? ");
    if(!confirmDelete){
      return;
    }
    deleteWebhook.mutate(
      {
        telegramId : data?._id
      },
      {
      onSuccess : () => {
        toast.showMessageSuccess("Xóa webhook thành công!");
        refetch();
      },
      onError : () =>{
        toast.showMessageError("Xóa webhook thất bại!");
        refetch();
      }
    }
    )

  }
    const handleChangStatus = async botTeleDetail => {
    const confirm = window.confirm('Bạn có chắc chắn muốn thay đổi trạng thái này không?');
    if (!confirm) {
      return;
    }

    changeBotTeleStatusMutation.mutate(
        { telegramId: botTeleDetail?._id },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Thay đổi trạng thái thành công');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Thay đổi trạng thái không thành công');
          refetch?.();
        },
      }
    );
  };

  const handleCreateWebhook =  data =>{
    const confirm = window.confirm("Bạn có muốn tạo webhook không?")
    if(confirm){
      createWebhook.mutate(
      { telegramId: data?._id},
      {
        onSuccess: () => {
          toast.showMessageSuccess("Tạo webhook thành công!");
          refetch();
        },
        onError:()=>{
          toast.showMessageError("Tạo webhook không thành công!");
          refetch();
        }
      }
    )
  }
  }

  const columnHelper = createColumnHelper();
  const onRowSelectionChange = newSelection => setRowSelection(newSelection);
  const columns = useMemo(
    () => [

      columnHelper.accessor('brandingId.name', {
        header: 'Branding',
        cell: info => (
          <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'UPDATE_PRODUCT_CATEGORY'}>
            <Flex alignItems="center" gap={2}>
              {<Text whiteSpace={"nowrap"}>{info.getValue()}</Text>}
                <IconButton
                  bg="transparent"
                  onClick={() => {
                    handleCreateWebhook(info?.row?.original);
                  }}
                >
                  <IoIosCreate cursor="pointer" boxSize={2} />
                </IconButton>
                <IconButton
                  bg="transparent"
                  onClick={() => {
                    handleDeleteWebhook(info?.row?.original);
                  }}
                >
                  <MdDeleteOutline cursor="pointer" boxSize={2} />
                </IconButton>
            </Flex>
          </AuthorizationComponentWrapper>
        ),
      }),
  
      columnHelper.accessor('isActive', {
        header: 'Is Active',
        cell: info => <Switch isChecked={info.getValue()} onChange={() => handleChangStatus(info?.row?.original)}></Switch>,
      }),

      columnHelper.accessor('action', {
        header: 'Thao tác',
        cell: info => (
          <AuthorizationComponentWrapper groupPermission={userInfo?.permissions} groupName={'UPDATE_PRODUCT_CATEGORY'}>
            <Flex alignItems="center" gap={1}>
              <IconButton
                bg="transparent"
                onClick={() => {
                  handleRowClick(info?.row?.original, ModalType.Add);
                }}
              >
                <EditIcon cursor="pointer" boxSize={4} />
              </IconButton>
              <IconButton
                bg="transparent"
                onClick={() => {
                  handleDeleteBotTele(info?.row?.original);
                }}
              >
                <DeleteIcon color="red.400" boxSize={4} />
              </IconButton>
            </Flex>
          </AuthorizationComponentWrapper>
        ),
      }),
    ],
    [botTeleTable]
  );

  var table = useReactTable({
    data: botTeleTable || [],
    columns,
    state: {
      sorting,
      rowSelection,
    },
    onSortingChange: setSorting,
    onRowSelectionChange,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true ,
    enableRowSelection: true,
    getRowId: row => {
      return row._id;
    },
  });
  
  return (
    <>
      <Table>
        <Thead>
          {table.getHeaderGroups().map(headerGroup => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <Th key={header.id}>
                  {header.isPlaceholder ? null : (
                    <Box w={'fit-content'} cursor={header.column.getCanSort() ? 'pointer' : 'default'}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </Box>
                  )}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {isEmpty(table.getRowModel().rows) ? (
            <Tr>
              <Td textAlign="center" colSpan={5}>
                Không có dữ liệu
              </Td>
            </Tr>
          ) : (
            table.getRowModel().rows.map(row => (
              <Tr key={row.id}>
                {row.getVisibleCells().map(cell => (
                  <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
                ))}
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </>
  );
};

export default SizeTable;
